import { Injectable } from '@angular/core'
import { createEffect, Actions, ofType } from '@ngrx/effects'
import { switchMap, catchError, of, withLatestFrom, filter, map } from 'rxjs'
import * as EventTicketPackageProfileActivitiesActions from './event-ticket-package-profile-activities.actions'
import { EventTicketPackageProfileActivitiesFacade } from './event-ticket-package-profile-activities.facade'
import { Action } from '@ngrx/store'
import { HttpErrorResponse } from '@angular/common/http'
import { AuctionFacade } from 'libs/gb-front/auction/data-access/src/lib/+state/auction.facade'
import { SelectedProfileFacade } from 'libs/gb-front/selected-profile/data-access/src/lib/+state/selected-profile.facade'
import { EventTicketPackageProfileActivitiesApiService } from './event-ticket-package-profile-activities-api.service'

@Injectable()
export class EventTicketPackageProfileActivitiesEffects {
  syncEventTicketPackageProfileActivity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        EventTicketPackageProfileActivitiesActions.syncEventTicketPackageProfileActivity,
        EventTicketPackageProfileActivitiesActions.updateSelectedEventTicketPackageProfileActivityId,
      ),
      withLatestFrom(this.auctionFacade.auctionUrlName$, this.selectedProfileFacade.selectedProfileId$),
      filter(([, , selectedProfileId]) => !!selectedProfileId),
      switchMap(([action, urlName]) =>
        this.eventTicketPackageProfileActivitiesApiService.syncActivity(urlName, action.uuid).pipe(
          map((activity) =>
            EventTicketPackageProfileActivitiesActions.syncEventTicketPackageProfileActivitySuccess({ activity }),
          ),
          catchError((error: HttpErrorResponse) =>
            of(
              EventTicketPackageProfileActivitiesActions.syncEventTicketPackageProfileActivityFailure({
                error,
                uuid: action.uuid,
              }),
            ),
          ),
        ),
      ),
    ),
  )

  syncEventTicketPackageProfileActivityFailure$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EventTicketPackageProfileActivitiesActions.syncEventTicketPackageProfileActivityFailure),
      withLatestFrom(this.eventTicketPackageProfileActivitiesFacade.allEventTicketPackageActivities$),
      switchMap(([action, activities]) => {
        const actions: Action[] = []
        if (
          action.error.status &&
          action.error.status === 404 &&
          action.uuid &&
          activities.some((activity) => activity.ticket_package.uuid === action.uuid)
        ) {
          actions.push(
            EventTicketPackageProfileActivitiesActions.deleteEventTicketPackageProfileActivity({ uuid: action.uuid }),
          )
        }
        return actions
      }),
    ),
  )

  constructor(
    private readonly actions$: Actions,
    private eventTicketPackageProfileActivitiesApiService: EventTicketPackageProfileActivitiesApiService,
    private eventTicketPackageProfileActivitiesFacade: EventTicketPackageProfileActivitiesFacade,
    private auctionFacade: AuctionFacade,
    private selectedProfileFacade: SelectedProfileFacade,
  ) {}
}
